<template>
    <div>
      <div v-if="toggle">
        <BaseFCPMap :elementId="mapId" :latitude="latitude" :longitude="longitude" :popupText="popupText" />
      </div>
    </div>
</template>

<script setup>

    const props = defineProps({
        practitioner: Object,
        toggle: Boolean
    })

    const { practitioner } = props
    const { profile, context } = useFCPModel()
    const { practitionerDetailUrl } = useUrls(context.value)
    const latitude = computed(() => practitioner.location.latitude)
    const longitude = computed(() => practitioner.location.longitude)
    const mapId = computed(() => `map-${practitioner.key}`)
    
    const practitionerName = computed(() => {
        const { first, middle, last, title } = practitioner.name
        return `${first} ${middle} ${last} ${title}`
    })

    const popupText = () => {
        const { practitioner } = props
        const { getPlan } = usePlan(profile.value, context.value)
        const plan = ref(getPlan())
        const { practitionerId, locationId, locationName, practicingSpecialty, distanceInMiles, tier } = practitioner
        const showTier = plan.value.isTiered && tier ? true : false
        const tierValue =
            plan.value.tierLabel == 'Benefit Tier'
            ? tier == 1
                ? `${plan.value.tierLabel}: Select`
                : `${plan.value.tierLabel}: Standard`
            : `${plan.value.tierLabel}: ${tier}`

        return `
                <hp5-semantic size-selection="xxs">
                    <div><hp5-link-text-basic size="xxs" text="${practitionerName.value}" href="${practitionerDetailUrl(
            practitionerId,
            locationId
        )}"></hp5-link-text-basic></div>
            <div><hp5-spacing-vertical sm="xxs"></hp5-spacing-vertical>${locationName ? locationName : ''}</div>
            <div><hp5-spacing-vertical sm="xxs"></hp5-spacing-vertical>${showTier ? tierValue : ''}</div>
            <div>${practicingSpecialty}</div>
            <div>${distanceInMiles} miles</div>
            </hp5-semantic>
            `
    }
  
  </script>